import { REHYDRATE } from "redux-persist";

import {
  AUTH0_CREATE_SESSION_FAILURE,
  AUTH0_CREATE_SESSION_REQUESTED,
  AUTH0_CREATE_SESSION_SUCCESS,
  AUTH0_EXCHANGE_CODE_FAILURE,
  AUTH0_EXCHANGE_CODE_REQUESTED,
  AUTH0_EXCHANGE_CODE_SUCCESS,
  SIGNOUT_SUCCESS,
  UPDATE_SESSION,
  UPDATE_USER_PASSWORD_REQUESTED,
  UPDATE_USER_PASSWORD_FAILURE,
  UPDATE_USER_PASSWORD_SUCCESS,
  UPDATE_USER_FAILURE,
  UPDATE_USER_REQUESTED,
  UPDATE_USER_SUCCESS,
} from "../actions/session-action-types";

const initialState = {
  user: null,
  account: null,
  role: null,
  updatingUser: false,
  auth0Accounts: [],
  auth0UserId: "",
  auth0IdToken: "",
  auth0ExchangeLoading: false,
  auth0ExchangeError: "",
  auth0CreateSessionLoading: false,
  auth0SubmittingAccountId: "",
};

export default function session(state = initialState, { payload, type }) {
  switch (type) {
    case UPDATE_SESSION:
      return {
        ...state,
        ...payload,
        auth0Accounts: [],
        auth0UserId: "",
        auth0IdToken: "",
        auth0ExchangeLoading: false,
        auth0ExchangeError: "",
        auth0CreateSessionLoading: false,
        auth0SubmittingAccountId: "",
      };
    case AUTH0_EXCHANGE_CODE_REQUESTED:
      return {
        ...state,
        auth0Accounts: [],
        auth0UserId: "",
        auth0IdToken: "",
        auth0ExchangeLoading: true,
        auth0ExchangeError: "",
      };
    case AUTH0_EXCHANGE_CODE_SUCCESS:
      return {
        ...state,
        auth0Accounts: payload?.accounts || [],
        auth0UserId: payload?.userId || "",
        auth0IdToken: payload?.idToken || "",
        auth0ExchangeLoading: false,
        auth0ExchangeError: "",
      };
    case AUTH0_EXCHANGE_CODE_FAILURE:
      return {
        ...state,
        auth0Accounts: [],
        auth0UserId: "",
        auth0IdToken: "",
        auth0ExchangeLoading: false,
        auth0ExchangeError: payload || "Failed to load accounts.",
      };
    case AUTH0_CREATE_SESSION_REQUESTED:
      return {
        ...state,
        auth0ExchangeLoading: false,
        auth0CreateSessionLoading: true,
        auth0SubmittingAccountId: payload || "",
        auth0ExchangeError: "",
      };
    case AUTH0_CREATE_SESSION_SUCCESS:
      return {
        ...state,
        auth0ExchangeLoading: false,
        auth0CreateSessionLoading: false,
        auth0SubmittingAccountId: "",
      };
    case AUTH0_CREATE_SESSION_FAILURE:
      return {
        ...state,
        auth0ExchangeLoading: false,
        auth0CreateSessionLoading: false,
        auth0SubmittingAccountId: "",
        auth0ExchangeError: payload || "Failed to create session.",
      };
    case UPDATE_USER_REQUESTED:
    case UPDATE_USER_PASSWORD_REQUESTED:
      return {
        ...state,
        updatingUser: true,
      };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        user: payload,
        updatingUser: false,
      };
    case UPDATE_USER_FAILURE:
    case UPDATE_USER_PASSWORD_FAILURE:
      return {
        ...state,
        updatingUser: false,
      };
    case UPDATE_USER_PASSWORD_SUCCESS:
      return {
        ...state,
        updatingUser: false,
      };
    case SIGNOUT_SUCCESS:
      return {
        ...initialState,
      };
    case REHYDRATE: {
      if (payload?.session) {
        return {
          ...initialState,
          ...payload.session,
        };
      }

      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
}
